import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import type { InformationSeverity, InformationType } from '../../interfaces/Information.interface';

@Injectable({
    providedIn: 'root'
})
export class InformationProvider {
    private _translate = inject(TranslateService);
    private _snackBar = inject(MatSnackBar);

    provideInformation(type: InformationType, message: string, severity: InformationSeverity = 'info', duration: number = 4000) {
        if (!message) return;

        this._snackBar.open(this._translate.instant(message), this._translate.instant('BUTTONS.CLOSE_TEXT'), {
            duration,
            verticalPosition: type === 'toast' ? 'bottom' : 'top',
            panelClass: ['info-' + severity, 'no-print'],
            politeness: 'assertive'
        });
    }

    showToast(message: string, severity: InformationSeverity | undefined = undefined, duration: number | undefined = undefined) {
        this.provideInformation('toast', message, severity, duration);
    }

    showNotification(message: string, severity: InformationSeverity | undefined = undefined, duration: number | undefined = undefined) {
        this.provideInformation('notification', message, severity, duration);
    }
}
